import React, { useState } from 'react';
import { toast } from 'react-toastify';
import authService from '../services/auth.service';

const ImpersonationBanner: React.FC = () => {
  const [stopping, setStopping] = useState(false);

  if (!authService.isMasquerading()) {
    return null;
  }

  const user = authService.getCurrentUser();
  const impersonator = authService.getImpersonator();

  const handleStop = async () => {
    setStopping(true);
    try {
      await authService.stopMasquerade();
      toast.success('Returned to your account');
      window.location.href = '/admin/users';
    } catch (error: any) {
      toast.error(error.message || 'Failed to stop masquerade session');
    } finally {
      setStopping(false);
    }
  };

  return (
    <div
      className='alert alert-warning mb-0 rounded-0 border-0 d-flex align-items-center justify-content-between px-4 py-2'
      role='alert'
      style={{ borderBottom: '1px solid #ffc107' }}
    >
      <div className='d-flex align-items-center gap-2'>
        <i className='ri-user-shared-line fs-18'></i>
        <span>
          Viewing as <strong>{user?.name}</strong> ({user?.email})
          {impersonator && (
            <span className='text-muted ms-1'>
              — signed in as {impersonator.name}
            </span>
          )}
        </span>
      </div>
      <button
        type='button'
        className='btn btn-sm btn-dark'
        onClick={handleStop}
        disabled={stopping}
      >
        {stopping ? 'Switching back…' : 'Stop masquerading'}
      </button>
    </div>
  );
};

export default ImpersonationBanner;
